import React from "react";

const NewsTicker = () => {

    const news = [
        "Admissions Open for Academic Year 2026-27",
        "Annual Sports Day will be held next week",
        "Parent Teacher Meeting scheduled on Saturday",
        "New Computer Lab inaugurated in the campus",
        "School achieved 100% board results this year"
    ];

    return (
        <div className="w-full bg-red-600 text-white text-sm h-8 flex items-center overflow-hidden relative z-[100]">

            {/* Label */}
            <div className="bg-white text-red-600 font-bold px-3 py-1 ml-3 rounded text-xs shrink-0">
                Latest
            </div>

            {/* Scrolling text */}
            <div className="ticker-wrapper ml-4">
                <div className="ticker-move">

                    {news.map((item, index) => (
                        <span key={index} className="mx-8">
                            🔔 {item}
                        </span>
                    ))}

                    {news.map((item, index) => (
                        <span key={`dup-${index}`} className="mx-8">
                            🔔 {item}
                        </span>
                    ))}

                </div>
            </div>

        </div>
    );
};

export default NewsTicker;